/* eslint-disable */

// This line is for the automated tests with node.js
if (typeof(exports) != 'undefined') { exports.deleteAllCookies = deleteAllCookies }

// https://stackoverflow.com/questions/179355/clearing-all-cookies-with-javascript
function deleteAllCookies() 
{
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) 
    {
        var cookie = cookies[i];
        var eqPos = cookie.indexOf("=");
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        // document.cookie = name + i + "=;path=/;expires=Thu, 12 Nov 2020 00:00:00 GMT";
        document.cookie = name + "=;path=/;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}


// WEBPACK FOOTER //
// ./src/utils/cookie.js